const LINK = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="10" cy="10" r="10" fill="#3468F4" />
    <path
      d="M10.0001 2.5L8.62395 3.29128L4.87395 5.45872L3.4978 6.25V13.75L4.87395 14.5413L8.65835 16.7087L10.0345 17.5L11.4106 16.7087L15.1262 14.5413L16.5024 13.75V6.25L15.1262 5.45872L11.3762 3.29128L10.0001 2.5V2.5ZM6.2501 12.1674V7.83257L10.0001 5.66514L13.7501 7.83257V12.1674L10.0001 14.3349L6.2501 12.1674Z"
      fill="white"
    />
  </svg>
);
export default LINK;
